import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { UserPrefsService } from '../core/services/user-prefs.service';
import { RouterOutlet } from '@angular/router';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TopBarComponent } from './top-bar/top-bar.component';
import { AppRailComponent } from './app-rail/app-rail.component';
import { ActiveAppService } from '../core/services/active-app.service';
import { AiSidebarComponent } from '../features/admin/dashboard/ai-assistant/components/ai-sidebar/ai-sidebar.component';

@Component({
    selector: 'ec-shell',
    imports: [
        RouterOutlet,
        TopBarComponent,
        AppRailComponent,
        AiSidebarComponent,
    ],
    templateUrl: './shell.component.html',
    styleUrl: './shell.component.scss',
    animations: [
        trigger('navSlide', [
            state('visible', style({ width: '240px', minWidth: '240px' })),
            state('hidden', style({ width: '0px', minWidth: '0px' })),
            transition('hidden <=> visible', animate('200ms cubic-bezier(0.4,0,0.2,1)')),
        ]),
    ]
})
export class ShellComponent implements OnInit {
  private readonly activeApp = inject(ActiveAppService);
  private readonly prefs = inject(UserPrefsService);

  readonly activeAppEntry = this.activeApp.activeApp;

  readonly navItems = computed(() => this.activeAppEntry()?.navItems ?? []);
  readonly navAppLabel = computed(() => this.activeAppEntry()?.label ?? '');
  readonly isNavVisible = computed(() => this.navItems().length > 0);
  readonly navState = computed(() =>
    this.isNavVisible() ? 'visible' : 'hidden',
  );

  isIframe = signal(false);

  ngOnInit(): void {
    try {
      this.isIframe.set(window.self !== window.top);
    } catch (e) {
      this.isIframe.set(true);
    }
    this.prefs.applyCurrentTheme();
  }
}
